import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";
import { hasTracking } from "@escapio/shared/state/client-settings";
import { proxyTrack } from "@escapio/portal/tracker/FacebookProxy";

customElements.define(
	"esc-facebook-loader",
	class extends HTMLElement {
		async connectedCallback() {
			if (!hasTracking) return;
			await hasAllPurposesConsent;
			this.load();
		}

		load() {
			/* eslint-disable no-undef */
			!(function (f, b, e, v, n, t, s) {
				if (f.fbq) return;
				n = f.fbq = function () {
					n.callMethod
						? n.callMethod.apply(n, arguments)
						: n.queue.push(arguments);
				};
				if (!f._fbq) f._fbq = n;
				n.push = n;
				n.loaded = !0;
				n.version = "2.0";
				n.queue = [];
				t = b.createElement(e);
				t.async = !0;
				t.src = v;
				s = b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t, s);
			})(
				window,
				document,
				"script",
				"//connect.facebook.net/en_US/fbevents.js",
			);

			fbq("init", "618502034916953");
			fbq("track", "PageView");
			proxyTrack("PageView");
		}
	},
);
